// extracted by mini-css-extract-plugin
export default {"ServicesPage":"style_ServicesPage__IVERO"};